import dayjs from 'dayjs';
import moment from 'moment';

export const dateFormat = 'DD/MM/YYYY';
export const monthYearFormat = 'MM/YYYY';
export const dateTimeFormat = 'DD/MM/YYYY hh:mm A';
export const timeFormat = 'hh:mm A';

export const displayDateAndTime = (date: string | number | Date | null | undefined) => {
  return dayjs(date).format(dateTimeFormat);
};

export const displayDate = (date: string | number | Date | null | undefined) => {
  if (date === null) {
    return '-';
  }
  return dayjs(date).format(dateFormat);
};

export const displayTime = (date: string | number | Date | null | undefined) => {
  return dayjs(date).format(timeFormat);
};

export const displayDateFromString = (date: string | moment.MomentInput) => {
  return moment(date).format(dateFormat);
};

export const displayUctTime = (date: string) => {
  return moment.utc(date).format(timeFormat);
};

export const getYearsOfCurrentEmployment = (
  employmentStartFrom: string,
  submissionDate: string
): string => {
  if (!employmentStartFrom || !moment(employmentStartFrom).isValid()) {
    return '';
  }

  const startDate = moment(employmentStartFrom);
  const currentDate = moment(submissionDate);

  if (startDate.isAfter(currentDate)) {
    return '';
  }

  const years = currentDate.diff(startDate, 'years', true);

  if (years < 0.08) {
    return 'less than 1 year';
  }

  if (years < 1) {
    return 'less than 1 year';
  }

  if (years <= 3) {
    return '>1 - 3';
  }

  if (years <= 5) {
    return '>3 - 5';
  }

  return '>5';
};

export const getEmploymentDuration = (employmentStartFrom: string): string => {
  if (!employmentStartFrom || !dayjs(employmentStartFrom).isValid()) {
    return '';
  }

  const startDate = dayjs(employmentStartFrom);
  const currentDate = dayjs(dayjs().endOf('day'));

  if (startDate.isAfter(currentDate)) {
    return '0 days';
  }

  const diffDuration = dayjs.duration(currentDate.diff(startDate));
  const years = diffDuration.years();
  const months = diffDuration.months();
  const days = diffDuration.days();

  const parts: string[] = [];

  if (years > 0) {
    parts.push(`${years} ${years === 1 ? 'year' : 'years'}`);
  }

  if (months > 0) {
    parts.push(`${months} ${months === 1 ? 'month' : 'months'}`);
  }

  if (days > 0 || (years === 0 && months === 0)) {
    parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);
  }

  if (parts.length === 0) {
    return '0 days';
  }

  if (parts.length === 1) {
    return parts[0];
  } else if (parts.length === 2) {
    return `${parts[0]} and ${parts[1]}`;
  } else {
    const lastPart = parts.pop();
    return `${parts.join(', ')} and ${lastPart}`;
  }
};
